export default "__VITE_ASSET__DPxVXJvs__"